import type { Search } from '../../types/Search';

export const searchBaseFeatureConfig: Search = {
    countryProductId: '',
    displayIssuerForShares: false,
    extraGroupTypeKeys: [],
    fetchDocuments: false,
    fetchRiskAcceptance: false,
    marketDataPortalLanguageUrls: {},
    showExperienceProfileMissingTooltip: false,
    showMarketPortalBanner: false,
    showPreorderScreenOnSuggestionClick: false,
    bondOfferingUrl: '',
    fundOfferingUrl: '',
};
